<div class="wrapper">
  <div class="back-link-container confinement">
    <a routerLink=".." class="back-on-mobile mat-h2 back-link">
      <mat-icon class="back-link-icon">arrow_back</mat-icon>
      {{ 'ACCOUNT.ADD_PAYMENT_METHOD.TITLE' | translate }}
    </a>
  </div>
  <mat-card class="confinement">
    <ng-container *ngIf="formState$ | async as formState">
      <form [ngrxFormState]="formState">
        <mat-card-title class="mat-title">
          {{ 'ACCOUNT.NEW_DEBIT_CHARGE.TITLE' | translate }}
        </mat-card-title>
        <mat-card-content class="mat-card-info">
          <p>{{ 'ACCOUNT.NEW_DEBIT_CHARGE.INFO' | translate : { company: environment.company } }}</p>

          <mat-form-field class="form-field" appearance="fill" gdColumns="auto">
            <mat-label
              >{{ 'ACCOUNT.NEW_DEBIT_CHARGE.ACCOUNT_OWNER' | translate
              }}<span class="required-field"> *</span></mat-label
            >
            <input matInput type="text" [ngrxFormControlState]="formState.controls.owner" maxlength="255" />
          </mat-form-field>
          <mat-form-field class="form-field" appearance="fill" gdColumns="auto">
            <mat-label>{{ 'ACCOUNT.NEW_DEBIT_CHARGE.BANK' | translate }}</mat-label>
            <input matInput type="text" [ngrxFormControlState]="formState.controls.bank" maxlength="255" />
          </mat-form-field>
          <mat-form-field class="form-field" appearance="fill" gdColumns="auto">
            <mat-label
              >{{ 'ACCOUNT.NEW_DEBIT_CHARGE.IBAN' | translate }}<span class="required-field"> *</span></mat-label
            >
            <input matInput type="text" [ngrxFormControlState]="formState.controls.iban" maxlength="43" />
          </mat-form-field>
          <mat-form-field class="form-field" appearance="fill" gdColumns="auto">
            <mat-label>{{ 'ACCOUNT.NEW_DEBIT_CHARGE.BIC' | translate }}</mat-label>
            <input matInput type="text" [ngrxFormControlState]="formState.controls.bic" maxlength="11" />
          </mat-form-field>
          <mat-checkbox [ngrxFormControlState]="formState.controls.sepaAgreement">
            <span class="checkbox-content">{{ environment.sepaAgreement_de }}</span
            ><span class="required-field">*</span>
          </mat-checkbox>
          <mat-checkbox [ngrxFormControlState]="formState.controls.sepaConditions"
            ><span class="checkbox-content">{{ environment.sepaConditions_de }}</span
            ><span class="required-field">*</span></mat-checkbox
          >
        </mat-card-content>
        <mat-card-actions>
          <span class="title-with-tooltip" style="justify-content: flex-end">
            <!--      <mat-button-toggle-->
            <!--        #button-->
            <!--        class="mat-flat-button dark-plain-button"-->
            <!--        ngClass.sm="left-button"-->
            <!--        ngClass.xs="bottom-distance"-->
            <!--        ><mat-icon color="primary" class="star-icon">{{ button.checked ? 'star' : 'star_border' }}</mat-icon-->
            <!--        ><span>{{ 'GENERAL.SET_AS_DEFAULT' | translate }}</span></mat-button-toggle-->
            <!--      >-->
            <span class="tooltip-container" *ngIf="!this.address?.address?.city" style="margin-right: 2rem">
              <mat-icon
                style="font-size: 48px; position: relative; top: -14px"
                color="warn"
                matTooltipClass="tooltip-text"
                matTooltipTouchGestures="auto"
                matTooltip="{{ 'ACCOUNT.NEW_DEBIT_CHARGE.TOOLTIP' | translate }}"
                >warning</mat-icon>
            </span>
            <button
              mat-flat-button
              color="primary"
              (click)="submitDebitCharge(formState)"
              [class.button-spinner]="this.pending"
              [disabled]="this.pending || this.formState.isInvalid || !this.address?.address?.city"
            >
              {{ 'ACCOUNT.NEW_DEBIT_CHARGE.CONFIRM' | translate }}
            </button>
          </span>
        </mat-card-actions>
      </form>
    </ng-container>
  </mat-card>
</div>
